const messages = {
    bonus: {
        title: "Übersicht Bonusgutschriften",
        description:
            "Boni in Euro werden an teilnehmende Unternehmen auf Grundlage der eingereichten Verkaufszahlen vergeben.",
        lastMonth: "Letzter Monat",
        currentMonth: "Aktueller Monat",
        totalCurrentYear: "Gesamtsumme laufendes Jahr",
        totalLastYear: "Gesamtsumme letztes Jahr",
    },
    points: {
        title: "Übersicht Punktegutschriften",
        period: "Aktuelles Kalenderjahr ({year})",
        totalAwarded: "Gesamt vergebene Punkte",
        redeemed: "Eingelöste Punkte",
        totalBalance: "Gesamtpunktestand",
        redemptionRate: "Eingelöste Punkte als Prozentsatz der vergebenen Punkte",
        averageAwarded: "Durchschnittlich vergebene Punkte pro gekauftem Reifen",
        standardAwarded: "Nettopunkte aus berechneten Verkaufszeilen, einschließlich Retouren",
        bsPlusInclBooster: "Punkte aus Verkaufszeilen mit positiver Menge",
        perTire: "Eingelöste Punkte pro gekauftem Reifen",
    },
    tires: {
        title: "Übersicht Reifenanzahl",
        description: "Von den Kunden gekaufte Reifen",
        prevMonth: "Vorheriger Monat",
        totalLastYear: "Gesamtsumme letztes Jahr",
        purchaseIndirect: "Einkauf über Großhändler (indirekt)",
        purchaseDirect: "Einkauf über Großhändler (direkt)",
        totalCurrentYear: "Gesamtsumme laufendes Jahr",
        currentMonth: "Aktueller Monat",
    },
    participating: {
        title: "Übersicht der teilnehmenden Kunden",
        description:
            "Unternehmen, die sich bei BRIDGESTONE PLUS registrieren, können von uns über die Kundennummer zugeordnet werden.",
        total: "Gesamt",
        newThisMonth: "Neu in diesem Monat",
        newThisYear: "Neu in diesem Jahr",
        createdInCurrentMonth: "Im aktuellen Monat erstellt (durch Admin)",
        loginsCurrentYear:
            "Anmeldungen im laufenden Jahr (nach Akzeptieren der AGB)",
    },
    brand: {
        title: "Marke",
        description: "Ihre Einkäufe im Detail",
        centerTitle: "Nach\nMarke",
    },
    rim: {
        title: "Felge",
        centerTitle: "Pro\nFelgengröße",
    },
    tireGoals: {
        title: "Reifenzielerreichung",
        subtitle: "Sammeln Sie Punkte für Ihre Reifenkäufe.",
        centerTitle: "Nach\nReifengröße",
        tiresRemaining: "Verbleibende Reifen",
        progressionTarget: "Fortschritt zum Ziel:",
        pointsEarnedPurchases:
            "Punkte gesammelt\n" + "durch Ihre\n" + "Einkäufe",
        pointsEarnedBoosters:
            "Punkte gesammelt\n" + "durch\n" + "Booster",
        purchasesDetail: "Ihre Einkäufe im Detail",
        cta: "Erfahren Sie mehr über Ihre Punkte",
        pointsTitle: "Ihre Punkte",
        pointsSubtitle: "Gesammelte Punkte durch Ihre Bridgestone-Käufe",
        achievementsTitle: "Ihre Erfolge",
        achievementsSubtitle: "Ihr jährliches Engagement:",
        achievementsSubtitle2: "Reifen",
    },
    score: {
        title: "Punktestand",
        total: "Gesamt",
        credits: "Gutschriften in",
        deductions: "Abzüge in",
        unlockedPoints: "Freigeschaltete Punkte",
        pendingPoints: "Ausstehende Punkte",
    },
    score_extended: {
        title1: "Punktebilanz",
        title2: "Bonus in Euro",
        balance: "Punktebilanz",
        bonus_in_euro: "Bonus in Euro",
        date: "Datum",
        added_points: "Punkte hinzugefügt am",
        total_bands: "Gesamtbänder",
        goal: "Ziel",
        tyres_previous_year: "Verkaufte Reifen im Vorjahr",
        tyres_current_year: "Verkaufte Reifen im laufenden Jahr",
        target_this_year: "Verkaufsziel dieses Jahr",
        bonus_this_year: "Verdienter Bonus (€)",
        loyal_minimum: "Mindestloyalitätsstufe",
        bonus_multiplier: "Bonus-Multiplikationsrate",
    },
    lastImport: {
        label: "Letzter Import der Verkaufszahlen:",
        on: "am",
    },
    wholesalerTable: {
        title: "Teilnehmende Kunden im Detail",
        description:
            "Unten finden Sie Unternehmen, die sich bei BRIDGESTONE PLUS mit der Kundennummer Ihres Unternehmens registriert haben. " +
            "Sie können die Filter zur Sortierung verwenden oder über die Suchfunktion nach bestimmten Kunden suchen.",
        downloadButton: "Downloads",
        columns: {
            customer_number: "Kundennr.",
            address_company_name: "Unternehmen",
            address_street: "Straße & Hausnummer",
            address_postal_code: "Postleitzahl",
            address_city: "Ort",
            last_registration: "Letzte Registrierung",
            network: "Netzwerk",
            profile_group: "Gruppe",
            tires_amount: "Reifenanzahl",
            point_balance: "Punktestand",
            bonus: "Bonus",
            details: "Details",
        },
        searchPlaceholder: "Suche",
    },
    dealerTable: {
        columns: {
            date: "Datum",
            wholesaler_bs_plus: "Großhändler BS+",
            customer_number: "Kundennummer",
            article: "Artikel",
            brand: "Marke",
            product: "Produkt",
            type: "Typ",
            inch: "Zoll",
            season: "Saison",
            amount: "Menge",
            points: "Punkte",
            activity: "Aktivität",
            total_points: "Gesamtpunkte",
        },
        title: "Händlerübersicht",
        description: "Übersicht der Händleraktivitäten",
    },
    business_units: {
        title: "Geschäftseinheiten",
        centerTitle: "Pro\nEinheit",
    },
    season: {
        title: "Saison",
        centerTitle: "Nach\nJahreszeit",
    },
};

export default {
    messages,
};
